var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1669 9.16666H7.84191L10.5919 6.42499C10.7488 6.26807 10.837 6.05524 10.837 5.83333C10.837 5.61141 10.7488 5.39858 10.5919 5.24166C10.435 5.08474 10.2222 4.99658 10.0002 4.99658C9.77832 4.99658 9.56549 5.08474 9.40857 5.24166L5.24191 9.40833C5.16604 9.48758 5.10657 9.58103 5.06691 9.68333C4.98356 9.88621 4.98356 10.1138 5.06691 10.3167C5.10657 10.419 5.16604 10.5124 5.24191 10.5917L9.40857 14.7583C9.48604 14.8364 9.57821 14.8984 9.67976 14.9407C9.78131 14.983 9.89023 15.0048 10.0002 15.0048C10.1102 15.0048 10.2192 14.983 10.3207 14.9407C10.4223 14.8984 10.5144 14.8364 10.5919 14.7583C10.67 14.6809 10.732 14.5887 10.7743 14.4871C10.8166 14.3856 10.8384 14.2767 10.8384 14.1667C10.8384 14.0566 10.8166 13.9477 10.7743 13.8462C10.732 13.7446 10.67 13.6525 10.5919 13.575L7.84191 10.8333H14.1669C14.3879 10.8333 14.5999 10.7455 14.7562 10.5892C14.9124 10.433 15.0002 10.221 15.0002 9.99999C15.0002 9.77898 14.9124 9.56702 14.7562 9.41074C14.5999 9.25446 14.3879 9.16666 14.1669 9.16666Z",
    fill: "#003A3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBack);
export default __webpack_public_path__ + "static/media/icon-arrow-back.eb7bbe4e3b44e8daadcd148eb6251c2b.svg";
export { ForwardRef as ReactComponent };